import {
  FETCH_FROM_OP_LISTING_FAILURE,
  FETCH_FROM_OP_LISTING_SUCCESS,
  RESET,
} from "./fromOptionsTypes";

const initialState = {
  allOptions: [],
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FROM_OP_LISTING_SUCCESS:
      return {
        allOptions: action.payload,
        error: null,
      };
    case FETCH_FROM_OP_LISTING_FAILURE:
      return {
        allOptions: [],
        error: action.payload,
      };
    case RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
